import baseRoute from '../baseRoute';

export default `${baseRoute}/deliverable` as const;
